// TYPES
// STYLES
import { useSelector } from 'react-redux';
import type { TRootState } from 'slices/store';
import type { TRolePermission } from '@timeedit/types/lib/types';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Popconfirm,
  Select,
} from '@timeedit/ui-components/antd';
// COMPONENTS
import SectionHeader from '../../../components/SectionHeader';
// i18N
import intl from '../../../i18n/intl';
import {
  rolePermissionGroupsSelector,
  selectAllowedActionsForGroup,
} from '../../../slices/rolePermission.slice';

type Props = {
  onChange: (prop: string, value: any) => void;
  onDelete: (rolePermissionId?: string | number) => void;
  onSelectRolePermissionGroup: (rolePermissionGroupId: string) => void;
  rolePermission: TRolePermission;
};

const language: any = intl.messages;

const RolePermissionDetailPage = ({
  onChange,
  onDelete,
  onSelectRolePermissionGroup,
  rolePermission,
}: Props) => {
  const [form] = Form.useForm();

  const rolePermissionGroups = useSelector(rolePermissionGroupsSelector);
  const allowedActionsForSelectedRolePermissionGroup = useSelector(
    (state: TRootState) =>
      selectAllowedActionsForGroup(state, rolePermission.rolePermissionGroup)
  );

  return (
    <>
      <SectionHeader
        listChoiceHeading={rolePermission.name || undefined}
        displayProp={false}
        history={false}
        extra={
          <Popconfirm
            title="Are you sure you want to delete this role permission? This action cannot be undone."
            onConfirm={() => onDelete(rolePermission.id)}
            okText="Delete"
            cancelText="Cancel"
          >
            <Button type="primary" disabled={rolePermission.id === 0} danger>
              Delete
            </Button>
          </Popconfirm>
        }
      />
      <Form layout="vertical" form={form}>
        <Form.Item label={language.name}>
          <Input
            size="small"
            value={rolePermission.name || undefined}
            onChange={(event) => onChange('name', event.target.value)}
          />
        </Form.Item>
        <p className="small-heading-text">
          {language.id}: {rolePermission.id}
        </p>
        <Form.Item label="Role permission group">
          <Select
            size="small"
            value={rolePermission.rolePermissionGroup || undefined}
            onChange={onSelectRolePermissionGroup}
          >
            {(rolePermissionGroups || []).map((group) => (
              <Select.Option value={group.id} key={group.id}>
                {group.id}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Enabled actions">
          {rolePermission.rolePermissionGroup ? (
            <Checkbox.Group
              options={allowedActionsForSelectedRolePermissionGroup.map(
                (action) => ({ value: action, label: action })
              )}
              value={rolePermission.groupActions}
              onChange={(checkedValues) =>
                onChange('groupActions', checkedValues)
              }
            />
          ) : (
            'Select a role permission group to view available actions'
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default RolePermissionDetailPage;
